import { BoardMeetingError } from "@boark/shared/utils/board-meeting";

import { useLocale } from "../stores/locale";

// Human readable reason for why an action is blocked
export function useBlockedReason(): (error: BoardMeetingError) => string {
  const { locale: t } = useLocale();
  const reasons: Partial<Record<BoardMeetingError, string>> =
    t.boardMeeting.blocked;
  return (error) => reasons[error] ?? error;
}
